const dev = process.env.NODE_ENV !== "production";
export const basePath = "https://tete-en-lair.fr";
